export enum ERuntimeType {
  UI = 'ui',
  API = 'api',
}

export const MANIFEST_API_RUNTIME_NAME = ERuntimeType.API;
